import { render } from "./MemberNotes.vue?vue&type=template&id=3e1bfad0&scoped=true"
import script from "./MemberNotes.vue?vue&type=script&lang=js"
export * from "./MemberNotes.vue?vue&type=script&lang=js"

import "./MemberNotes.vue?vue&type=style&index=0&id=3e1bfad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1bfad0"]])

export default __exports__